import * as util from '#packages/util';
import { storePagesData, getPagesData } from './api';
import type { Scope } from './scope';
import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';
import experiment from 'experiment';

const { showUserActionNotification } = stateManagement.notifications.actions;

export async function init(scope: Scope) {
  const { publishManagerApi } = scope;

  const getAutoRedirectApi = () =>
    import('advancedSeoClient').then(
      ({ createAutoRedirect, getBeforePublishedPages }) => ({
        createAutoRedirect,
        getBeforePublishedPages,
      }),
    );

  publishManagerApi.hooks.beforePublish.tap(async () => {
    const autoRedirectApi = await getAutoRedirectApi();
    const beforePublishPages = await autoRedirectApi.getBeforePublishedPages({
      scope,
      experiment,
      metaSiteAppId: constants.APPLICATIONS.META_SITE_APPLICATION_ID,
    });
    storePagesData(scope, beforePublishPages);
  });

  publishManagerApi.hooks.afterPublish.tap(async () => {
    const beforePublishedPages = getPagesData(scope);
    const autoRedirectApi = await getAutoRedirectApi();
    await autoRedirectApi.createAutoRedirect({
      scope,
      experiment,
      beforePublishedPages,
      metaSiteAppId: constants.APPLICATIONS.META_SITE_APPLICATION_ID,
      locale: util.languages.getLanguageCode(),
      showUserActionNotification,
    });
  });
}
